import { zingayaWidgetId } from './constants/common';

export default function zingayaCall() {
  const nextWindow = window.open(
    `http://zingaya.com/widget/${zingayaWidgetId}?referrer=${escape(window.location.href)}`,
    'zingaya',
    'width=236,height=220,resizable=no,toolbar=no,menubar=no,location=no,status=no'
  );

  setTimeout(() => {
    nextWindow.focus();
  }, 500);
}
